import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

import { reviewApi, type CandidateReview, type Decision } from "../api/review";

export function DecisionForm({ review }: { review: CandidateReview }) {
  const queryClient = useQueryClient();
  const [decision, setDecision] = useState<Decision | "">("");
  const [reasoning, setReasoning] = useState("");
  const decide = useMutation({
    mutationFn: () => reviewApi.decide(review.header.public_id, decision as Decision, reasoning),
    onSuccess: (updated) => {
      queryClient.setQueryData(["review", "candidate", review.header.public_id], updated);
      void queryClient.invalidateQueries({ queryKey: ["review", "queue"] });
      setReasoning("");
    },
  });
  return (
    <section id="decision">
      <h2>Decision</h2>
      {review.reviews.length > 0 && (
        <ul>
          {review.reviews.map((r, i) => (
            <li key={i}>
              <strong>{r.reviewer_login}</strong>: {r.decision} — {r.reasoning}{" "}
              <span className="muted">({new Date(r.created_at).toLocaleString()})</span>
            </li>
          ))}
        </ul>
      )}
      <p className="muted">
        Decline needs two reviewers ({review.decline_votes} of 2 so far). Your latest decision
        replaces your earlier one.
      </p>
      <fieldset>
        <legend>Your decision</legend>
        {(["interview", "hold", "decline"] as const).map((value) => (
          <label key={value} className="choice">
            <input
              type="radio"
              name="decision"
              checked={decision === value}
              onChange={() => setDecision(value)}
            />
            {value[0]?.toUpperCase() + value.slice(1)}
          </label>
        ))}
      </fieldset>
      <label htmlFor="reasoning">One line of reasoning (required)</label>
      <input
        id="reasoning"
        maxLength={500}
        value={reasoning}
        onChange={(e) => setReasoning(e.target.value)}
      />
      {decide.isError && <p role="alert">{decide.error.message}</p>}
      <button
        type="button"
        disabled={!decision || !reasoning.trim() || decide.isPending}
        onClick={() => decide.mutate()}
      >
        Record decision
      </button>
    </section>
  );
}
